var chunkMapping = {
	"171": [
		3457
	],
	"531": [
		2774,
		5620,
		5894,
		5899,
		6467,
		7693,
		8447,
		9319,
		9910
	],
	"2462": [
		8845
	]
};
var idToExternalAndNameMapping = {
	"2774": [
		"default",
		"./UnboxingPageDescription",
		8235
	],
	"3457": [
		"default",
		"./Utils",
		7672
	],
	"5620": [
		"default",
		"./UnboxingPageRow",
		8235
	],
	"5894": [
		"default",
		"./UnboxingPageCol",
		8235
	],
	"5899": [
		"default",
		"./UnboxingPageGetStarted",
		8235
	],
	"6467": [
		"default",
		"./hooks",
		1441
	],
	"7693": [
		"default",
		"./Selectors",
		1441
	],
	"8447": [
		"default",
		"./UnboxingPageIntroduction",
		8235
	],
	"8845": [
		"default",
		"./Store",
		7672
	],
	"9319": [
		"default",
		"./UnboxingPageContent",
		8235
	],
	"9910": [
		"default",
		"./hooks",
		7883
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}